<script setup lang="ts">
import TabMenu from "@/components/TabMenu.vue";
import {IBaseMenuItem} from "@/models";

const props = defineProps({
  menuItems: {type: Array as () => IBaseMenuItem[], default: []},
});
</script>

<template>
  <div id="ct" class="flex-layout-body">
    <nav class="nav nav-files">
      <tab-menu :items="menuItems" :li="false" :depths="4" />
    </nav>
    <!-- [D] 선택 된 순서 data-file="숫자" -->
    <div class="file-content" data-file="2">
      <strong class="file-title">수익 정산 집계</strong>
      <router-view :menu-items="menuItems[1].children"></router-view>
    </div>
  </div>
</template>

<style scoped>

</style>